import { handleError } from "../common/ErrorUtil";

import { executeGraphql, executeGraphqlLoop } from "./BaseApi";
import { uploadReferenceLine } from "./graphql/mutations";
import { listReferenceLines } from "./graphql/queries";

/**
 * グラフ線図一覧取得APIの実行.
 *
 * @param {string} serialNumber 工番
 * @return {object} レスポンス
 */
export async function executeListReferenceLines(serialNumber) {
  const params = {
    serialNumber,
  };
  const key = "listReferenceLines";
  const { data, error } = await executeGraphqlLoop(
    listReferenceLines,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = data[key].items;
  } else {
    response.data = [];
  }

  return response;
}

/**
 * グラフ線図登録APIの実行.
 *
 * @param {string} serialNumber 工番
 * @param {array} info グラフ線図情報
 * @return {object} レスポンス
 */
export async function executeUploadReferenceLine(serialNumber, info) {
  const params = {
    input: {
      serialNumber,
      data: info,
    },
  };
  const { data, error } = await executeGraphql(
    uploadReferenceLine,
    params
  ).catch(handleError);

  const key = "uploadReferenceLine";
  const response = { error };
  if (data && data[key]) {
    response.data = JSON.parse(data[key]);
  } else {
    response.data = {};
  }
  return response;
}
